"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';

var ExplainPanel = function ExplainPanel(props) {
  var iconUrl = props.iconUrl,
    title = props.title,
    description = props.description,
    className = props.className,
    style = props.style;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('explain-panel');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__hd")
  }, !!iconUrl && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__icon")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "__icon-img"),
    src: iconUrl
  })), !!title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__tit")
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__bd")
  }, Array.isArray(description) ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__desc")
  }, description.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__desc-item"),
      key: index
    }, item);
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__desc")
  }, description)));
};
ExplainPanel.defaultProps = {};
var _default = exports.default = ExplainPanel;